export default "/kiban/_next/static/images/orange-4af9918be13bcf81d26e7eb5cafb6d8a.png";